/* eslint-disable consistent-return */
/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useState } from 'react';
import { Field, reduxForm } from 'redux-form';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControl from '@material-ui/core/FormControl';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { toastError, toastSuccess } from '../../../redux/actions/alertActions';
import userServices from '../../../redux/services/userServices';

const renderField = ({
  input, placeholder, type, meta: { touched, error },
}) => (
  <div className="form__form-group-input-wrap form__form-group-input-wrap--error-above">
    <input {...input} placeholder={placeholder} type={type} />
    {touched && error && <span className="form__form-group-error">{error}</span>}
  </div>
);

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    width: '100%',
    marginTop: '15px',
  },
  input: {
    color: 'white',
  },
  rootField: {
    background: 'white',
  },
}));

const PasswordForm = (props) => {
  const { changeTab, passwordToken } = props;
  const classes = useStyles();

  const [values, setValues] = React.useState({
    password: '',
    showPassword: false,
  });

  const [valuestwo, setValuestwo] = React.useState({
    password: '',
    showPassword: false,
  });

  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
  };

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleChangeTwo = (prop) => (event) => {
    setValuestwo({ ...valuestwo, [prop]: event.target.value });
  };

  const handleClickShowPasswordTwo = () => {
    setValuestwo({ ...valuestwo, showPassword: !valuestwo.showPassword });
  };

  const sendNewPassword = () => {
    const valOne = values.password;
    const valTwo = valuestwo.password;

    if (!valOne && !valTwo) {
      toastError('No password set');
      return;
    }
    if (valOne !== valTwo) {
      toastError('Two password are not similar');
      return;
    }
    const log = {
      token: passwordToken,
      password: valOne,
    };

    userServices.resetPassword(JSON.stringify(log))
      .then((res) => {
        if (res === null || res.error) {
          toastError(res.error);
        } else {
          toastSuccess('Password successfully updated!');
          changeTab(0);
        }
      });
  };

  return (
    <>
      <Typography component="h1" variant="h5">
        <FormattedMessage id="Login.ChangePassword" defaultMessage="Change your password" />
      </Typography>
      <Grid container style={{ width: '100%' }}>
        <Grid xs="12">
          <FormControl className={classes.textField} variant="outlined">
            <InputLabel htmlFor="outlined-adornment-password">
              <FormattedMessage id="Login.NewPassword" defaultMessage="New password" />
            </InputLabel>
            <OutlinedInput
              id="outlined-adornment-password"
              type={values.showPassword ? 'text' : 'password'}
              value={values.password}
              className={classes.rootField}
              onChange={handleChange('password')}
              endAdornment={(
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {values.showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
            )}
              labelWidth={120}
              InputProps={{
                className: classes.input,
              }}
            />
          </FormControl>
        </Grid>
        <Grid xs="12">
          <FormControl className={classes.textField} variant="outlined">
            <InputLabel htmlFor="outlined-adornment-password">
              <FormattedMessage id="Register.ConfirmPassword" defaultMessage="Confirm your password" />
            </InputLabel>
            <OutlinedInput
              id="outlined-adornment-password"
              type={valuestwo.showPassword ? 'text' : 'password'}
              value={valuestwo.password}
              onChange={handleChangeTwo('password')}
              className={classes.rootField}
              endAdornment={(
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPasswordTwo}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {valuestwo.showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
            )}
              labelWidth={170}
              InputProps={{
                className: classes.input,
              }}
            />
          </FormControl>
        </Grid>
        <Grid xs="12">
          <Button color="primary" variant="contained" onClick={() => sendNewPassword()} style={{ width: '100%', marginTop: '20px' }}>
            <FormattedMessage id="Common.submit" defaultMessage="Submit " />
          </Button>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item>
          <div
            style={{ cursor: 'pointer', color: '#1D3A74', marginTop: '10px' }}
            onClick={() => changeTab(0)}
          >
            Return to Login
          </div>
        </Grid>
      </Grid>
    </>
  );
};

PasswordForm.propTypes = {
  changeTab: PropTypes.func.isRequired,
};

export default reduxForm({
  form: 'password_form',
  destroyOnUnmount: true,
})(PasswordForm);
